module.exports = __webpack_public_path__ + "assets/img/2b4dcce558c7653f4c9d020ceb031dc1.b9256efa.png";